import React from 'react';

interface CardParams {
  header?: string;
  title?: string;
  titleStyle?: React.CSSProperties;
  isLoading?: boolean;
  children: React.ReactNode;
}

export default function Card({
  header,
  title,
  titleStyle,
  isLoading = false,
  children,
}: CardParams) {
  return (
    <div className='card'>
      {header && <div className='card-header'>{header}</div>}
      <div className='card-body overflow-auto'>
        {isLoading ? (
          <div className='text-center'>
            <strong role='status'>Carregando...</strong>
            <div className='d-flex justify-content-center'>
              <div className='spinner-border mt-5' role='status'>
                <span className='visually-hidden'>Carregando...</span>
              </div>
            </div>
          </div>
        ) : (
          <div>
            {title && (
              <h5 className='card-title' style={titleStyle}>
                {title}
              </h5>
            )}
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
